import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Pipe({
  name: 'monetaryValue',
})
export class ConvertMonetaryPipe implements PipeTransform {
  transform(value: NullSafe<string | number>): string {
    return NormalizerHelper.monetaryValue(value);
  }
}
